/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "522")




  export type API48413Req = {};



export interface API48413Res {
  /** 是否有权限,false:没有权限,true:有权限  */
  havePermission?: boolean;
  /** 项目数量 ,ProjectNumResp  */
  projectNum?: any;
  /** 项目平均进度 ,ProjectAvgResp  */
  projectAvg?: any;
  /** 项目健康指数 ,ProjectHealthFlagResp  */
  projectHealthFlag?: any;
  /** 任务数量 ,TaskNumResp  */
  taskNum?: any;
  /** 项目人员 ,TeamMemberResp  */
  projectMember?: any;
  
};


// 48413 项目概览

export interface IUseGetAPI48413Return {
  /** 项目概览: 接口请求状态 */
  isAPI48413Loading: boolean;
  /** 项目概览: 接口请求返回数据 */
  dataAPI48413: API48413Res;
  /**  项目概览: 接口数据请求方法 */
  fetchAPI48413Data:  ( config?: YWRequestConfig) => Promise<API48413Res>;
  /** 项目概览: 接口请求URL */
  requestUrl: string;
}

export const useGetAPI48413 = ():IUseGetAPI48413Return => {
  let isMount = true;
  const [isAPI48413Loading, setIsAPI48413Loading] = useState(false);
  const [dataAPI48413, setDataAPI48413] = useState<API48413Res>({} as API48413Res);
  const requestUrl = `${basePath}/corp-admin/project/bi/v1`;

  const fetchAPI48413Data = async ( config?: YWRequestConfig): Promise<API48413Res> => {
  
    if ( isMount ) {
      setIsAPI48413Loading(true);
    }

    try {
      
      
      const res: any = await Request.get<API48413Res>(`${basePath}/corp-admin/project/bi/v1`, {
        loginHost: loginPath,
        ...config
      });
      
      
      
      if (isMount) {
        setDataAPI48413(res || {} as API48413Res);
        setIsAPI48413Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI48413Loading(false);
      }
      return false as unknown as API48413Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI48413Loading,
    dataAPI48413,
    fetchAPI48413Data,
    requestUrl,
  }
}

